import {
  UPDATE_CAMPAIGN,
  UPDATE_CAMPAIGN_FAILURE,
  UPDATE_CAMPAIGN_SUCCESS,
} from './action';

const initialState = {
  loading: false,
  data: [],
  error: '',
};

const updateCampaignReducer = (state = initialState, action) => {
  switch (action.type) {
    case UPDATE_CAMPAIGN:
      return { ...state, loading: true };
    case UPDATE_CAMPAIGN_SUCCESS:
      return { ...state, loading: false, data: action.payload, error: '' };
    case UPDATE_CAMPAIGN_FAILURE:
      return { ...state, loading: false, data: [], error: action.payload };
    default:
      return state;
  }
};

export default updateCampaignReducer;
